import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {CopilotChatEntitlementResult} from '@github-ui/copilot-entitlement/copilot-chat-entitlement'
import {CopilotLicenseType} from '@github-ui/copilot-chat-types'

export const useEntitlementData = () => {
  const {data} = useQuery<CopilotChatEntitlementResult>({
    queryKey: ['copilot-chat', 'entitlement'],
    queryFn: async () => {
      const response = await verifiedFetchJSON('/github-copilot/chat/entitlement')

      if (!response.ok) {
        throw new Error(`Failed to retrieve Copilot chat entitlement (${response.status} on ${response.url})`)
      }

      return (await response.json()) as CopilotChatEntitlementResult
    },
    placeholderData: {
      licenseType: CopilotLicenseType.Unlicensed,
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    plan: data?.plan,
    licenseType: data?.licenseType ?? CopilotLicenseType.Unlicensed,
  }
}

export const usePlan = () => {
  const {plan} = useEntitlementData()
  return plan
}
